<template>
  <div id="app_p">
    <van-tabs :color='tabcolor' v-model="active">
      <van-tab title="未完成">
        <div class="tbody">
          <div class="conent">
            <div class="conentbox">
              <div class="conentboxrow">
                <div>订单编号:LM202271101</div>
                <div class="waitpay">待支付</div>
              </div>
            </div>
            <h4 style="margin: 0 15px 0px 15px; padding-top: 10px">
              20220711健康管理师考证理论知识考试
            </h4>
            <div class="projectflex">
              <div>考试科目：理论</div>
              <div>支付人数：50人</div>
            </div>

            <div class="projectflex">
              <div>工种：健康管理师</div>
              <div>考试等级：三级高级工</div>
            </div>
            <div class="row_footer">
              <div style="
                  margin-top: 15px;
                  margin-left: 12px;
                  color: red;
                  float: left;
                  font-weight: 700;
                ">
                ￥10000
              </div>
              <van-button @click="gopay" type="danger" size="mini"
                style="float: right; margin-right: 10px; margin-top: 12px">前往支付</van-button>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="已完成">
        <div class="tbody">
          <div class="conent content_is">
            <div class="conentboxrowis">
              <div>订单编号:LM202271101</div>
            </div>
            <h4 style="margin: 0 15px 0px 15px; padding-top: 10px">
              20220711健康管理师考证理论知识考试
            </h4>
            <div class="projectflex">
              <div>考试科目：理论机构</div>
              <div>支付人数：50人</div>
            </div>
            <div class="projectflex">
              <div>工种：健康管理师</div>
              <div>考试等级：三级高级工</div>
            </div>
            <div style="margin: 5px 0 8px 15px" class="deactive"> 付款时间：2022-08-04 010:10:00</div>
            <div style="margin: 5px 0 8px 15px" class="deactive"> 付款方式：线上支付</div>
            <div class="row_footer">
              <div style="
                  margin-top: 19px;
                  margin-left: 12px;
                  color: red;
                  float: left;
                  font-weight: 700;
                ">
                ￥10000
              </div>
              <van-button @click="checkpay" type="info" size="small"
                style="float: right; margin-right: 10px; margin-top: 13px ">&nbsp;&nbsp;&nbsp;查看&nbsp;&nbsp;&nbsp;
              </van-button>
            </div>
          </div>
        </div>

      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import headerBox from '@/components/header.vue'
export default {
  components: {
    headerBox,
  },
  data() {
    return {
      tabcolor: '#54B0FB',
      active: 0
    }
  },
  created: function() {
    this.getOrderList()
  },
  methods: {
    getOrderList: function() {
      let params = {
        status: ''
      }
      this.$http.get('/registration/order/status', {params}).then(res => {
        if(res.data.success){
          console.log(res.data)
        }
      })
    },
    gopay() {
      this.$router.push({ path: '/order_mypay' })
    },
    checkpay() {
      this.$router.push({ path: '/order_payinfojigou' })
    }
  }
}
</script>

<style lang='less' scoped>
#app_p {

  background-color: #eee;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 28px;
  width: 100%;
  height: 100vh;

  ::v-deep .van-tabs--line .van-tabs__wrap {
    width: 100%;
    height: @tabheight;




  }
}

// #top {
//   width: 100%;
//   height: 70px;
//   line-height: 70px;
//   vertical-align: middle;
//   /* padding-top: 40px; */
//   background-color: rgba(245, 245, 245);
// }
.rightcha {
  float: left;
}

.centerwz {
  /* display: block; */
  padding: 0px;
  font-size: 30px;
  line-height: 70px;
}

.conent {
  height: 364px;
  background-color: @whitee;

  .conentboxrowis {
    //  height: 100%;
    line-height: @contH;
    display: flex;
    justify-content: flex-start;
    margin-top: 6px;
    padding: 0 @paddingpay;
    border-bottom: @allboxbordermin;
  }

  .row_footer {
    margin-top: @circle;
    border-top: @allboxbordermin;
  }

  .projectflex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: @paddingorder @paddingpay 0 @paddingpay;
  }

  .contentproject {
    padding: @paddingorder 0 0 @paddingpay;
  }

  .conentbox {
    height: @contH;

    border-bottom: @allboxbordermin;

    // .contentproject{
    //   padding-left: @paddingpay;
    // }
    .conentboxrow {
      height: 100%;
      line-height: @contH;
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
      padding: 0 @paddingpay;

      .waitpay {
        color: red;
      }
    }
  }


}

.deactive {
  color: rgb(226, 224, 224);

}

.content_is {
  height: 476px !important;
}

#top {

  text-align: center;
  height: @headerh;
  box-sizing: border-box;
  padding-top: @headerpt;
  background-color: @backgroundcolor;
  padding-bottom: @headerpb;
}
</style>